module.exports = __webpack_public_path__ + "static/media/stockspotBanner.d4f4fcd3.png";